import { PhonePrepareOutgoingEvent } from '@modules/SoftPhoneModule/types';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { matchesNetworkTestDial } from '@modules/SoftPhoneModule/lib/networkTestDial';

function handleTaskPrepareOutbound(
  _context: InboxContext,
  eventData: PhonePrepareOutgoingEvent,
): void {
  const { outgoingNumber, displayName, tenantId, taskAttributes } = eventData;
  if (matchesNetworkTestDial(outgoingNumber)) {
    return;
  }
  TasksModule.createOutboundCallTask(
    outgoingNumber,
    displayName,
    tenantId,
    taskAttributes,
  );
}

export default handleTaskPrepareOutbound;
